import { render, staticRenderFns } from "./gb-ant-select-pagination.vue?vue&type=template&id=1e291dd0&"
import script from "./gb-ant-select-pagination.vue?vue&type=script&lang=js&"
export * from "./gb-ant-select-pagination.vue?vue&type=script&lang=js&"
import style0 from "./gb-ant-select-pagination.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports